import { registerPlugins } from "@/application/plugins";
import { initKeycloak } from "@/application/plugins/keycloak";
import router from "@/router";

import App from "@/App.vue";

import { createApp } from "vue";

async function bootstrap() {
  await initKeycloak();

  const app = createApp(App);

  registerPlugins(app);

  await router.isReady();

  app.mount("#app");
}

bootstrap();
